// extracted by mini-css-extract-plugin
export default {"btn":"HoldRequestRow_btn__CZdTZ","table-number-cell":"HoldRequestRow_table-number-cell__YAQ6-","tr":"HoldRequestRow_tr__faPux"};